import type { PrototypeCatalogEntity } from "../../entity_types/catalog";

export const catalog_roen_pdp_refresh: PrototypeCatalogEntity = {
  token: "catalog_roen_pdp_refresh",
  type: "catalog",
  name: "ROEN PDP Refresh Catalog",
  brandToken: "catalog_brand_roen",
  collectionTokens: [],
  categoryTokens: [],
  productTokens: [
    "legacy_prod_roen-1",
    "legacy_prod_roen-2",
    "legacy_prod_roen-3",
    "legacy_prod_roen-4",
    "legacy_prod_roen-5",
    "legacy_prod_roen-6",
    "legacy_prod_roen-7",
    "legacy_prod_roen-8",
    "legacy_prod_roen-9",
    "legacy_prod_roen-10",
    "legacy_prod_roen-11",
    "legacy_prod_roen-12",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
